import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import SceneProducts from '@elem/compCommon/SceneProducts';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import D_AU from './components/D_AU';
import E from './components/E';
import F from './components/F';
import F_NA from './components/F_NA';
import G from './components/G';
import H from './components/H';
import J from './components/J';
import J_AU from './components/J_AU';
import JoinUs from './components/JoinUs';
import K from './components/K';
import K_NA from './components/K_NA';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import Power from './components/Power';
import Thumb from './components/Thumb';
import B_AU from './components/B_AU';
import SectionLeftInfo from './components/SectionLeftInfo';
import AuPreparing from './components/AuPreparing';
import { POWER_GENERATION_PRODUCTS, POWER_USAGE_PRODUCTS } from './config/auProductCards';
import { useGlobal } from '@/utils/useGlobal';
import ProductInlineBanner from '@/components/PIBanner';

const HIDE_BLOG_SITE = ['eu', 'kr', 'nl'];

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('outdoorrecreation');
    const IS_NA = ['us', 'ca'].includes(locale);

    const obj: SideMenuProps = {
        items: IS_NA
            ? [
                  {
                      text: t('secC_card1_title'),
                      link: '#outdoor-recreation-D',
                  },
                  {
                      text: t('secC_card2_title'),
                      link: '#outdoor-recreation-J',
                  },
              ]
            : [
                  { text: t('secC_list1_title'), link: '#outdoor-recreation-G' },
                  { text: t('secC_list2_title'), link: '#outdoor-recreation-D' },
                  { text: t('secC_list3_title'), link: '#outdoor-recreation-J' },
              ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const entry_position: any = {
        us: 12,
        ca: 12,
        au: 11,
        za: 9,
    };

    if (['au'].includes(locale)) {
        return (
            <>
                <B_AU />
                <C />
                <SectionLeftInfo
                    id="outdoor-recreation-power-generation"
                    img={{
                        src: 'https://websiteoss.ecoflow.com/figma-uploads/1786085776910-fkap4b-compressed-Power%20Generation.webp',
                        srcPad: 'https://websiteoss.ecoflow.com/figma-uploads/1786085776910-fkap4b-compressed-Power%20Generation.webp',
                        srcMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786349010191-bp7py5-compressed-Frame%202094655061.webp',
                    }}
                    title={t('section_info_1_title')}
                    desc={t('section_info_1_desc')}
                />
                <SceneProducts
                    id="outdoor-recreation-power-generation-products"
                    cards={POWER_GENERATION_PRODUCTS}
                    texts={{
                        buyNow: t('common_card_buyNow'),
                        more: t('common_card_more'),
                        out: t('common_card_out'),
                        listName: t('section_info_1_title'),
                        worksWith: t('works_best_with'),
                    }}
                />
                <SectionLeftInfo
                    id="outdoor-recreation-power-storage"
                    img={{
                        src: 'https://websiteoss.ecoflow.com/figma-uploads/1786086015241-p17k3b-compressed-Power%20Storage.webp',
                        srcPad: 'https://websiteoss.ecoflow.com/figma-uploads/1786349606671-lwy1kt-compressed-Frame%202094655063.webp',
                        srcMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786349606671-lwy1kt-compressed-Frame%202094655063.webp',
                    }}
                    title={t('section_info_2_title')}
                    desc={t('section_info_2_desc')}
                    btnText={t('section_info_2_btn')}
                    btnLink="https://www.ecoflow.com/au/ecoflow-power-kits/series"
                />
                <AuPreparing />
                <SectionLeftInfo
                    id="outdoor-recreation-power-usage"
                    img={{
                        src: 'https://websiteoss.ecoflow.com/figma-uploads/1786086020897-obnm77-compressed-Power%20Usage.webp',
                        srcPad: 'https://websiteoss.ecoflow.com/figma-uploads/1786349636991-mwjm7w-compressed-Frame%202094655068.webp',
                        srcMobile: 'https://websiteoss.ecoflow.com/figma-uploads/1786349639922-yezorz-compressed-Frame%202094655069.webp',
                    }}
                    title={t('section_info_3_title')}
                    desc={t('section_info_3_desc')}
                />
                <SceneProducts
                    id="outdoor-recreation-power-usage-products"
                    cards={POWER_USAGE_PRODUCTS}
                    texts={{
                        buyNow: t('common_card_buyNow'),
                        more: t('common_card_more'),
                        out: t('common_card_out'),
                        listName: t('section_info_3_title'),
                        worksWith: t('works_best_with'),
                    }}
                />
                <O />
            </>
        );
    }

    return (
        <>
            <B />
            {IS_NA && (
                <>
                    <Thumb />
                    <Power />
                </>
            )}
            {!IS_NA && <C />}
            {['au'].includes(locale) ? <D_AU /> : <D />}
            <E />
            {IS_NA && <ProductInlineBanner />}
            {!['kr'].includes(locale) && <F />}
            {!['us', 'ca', 'au', 'za'].includes(locale) && (
                <>
                    <G />
                    <H />
                </>
            )}
            {['au'].includes(locale) ? <J_AU /> : <J />}
            {IS_NA ? <K_NA /> : <K />}
            {['au'].includes(locale) && <JoinUs />}
            {IS_NA && <F_NA />}
            <EmailSubscribe
                locale={locale}
                className="email-subscribe"
                pageType={PAGE_TYPE.OutdoorRecreation}
                entry_position={entry_position[locale] || entry_position['us']}
            />
            {!['kr'].includes(locale) && <L />}
            <M />
            {!HIDE_BLOG_SITE.includes(locale) && <N />}
            <O />
            <h2 className="annotation">{t('secP')}</h2>
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
